import React from 'react';
import { navigate } from 'gatsby';
import { css } from '@emotion/core';
import ExternalLink from 'components/ExternalLink';
import { categories, categoriesWork, categoriesSeelsorge } from 'utils/helpers';
import { media } from 'utils/media';
import { isLoggedIn } from 'utils/auth';
import { AppStateContext } from 'state/appstate';

const IconMenu = (props) => {
  const { appValue, getAppColors } = React.useContext(AppStateContext);

  const appColor = getAppColors();

  const onClickIcon = (value) => {
    if (typeof window !== 'undefined') {
      if (isLoggedIn()) {
        window.localStorage.setItem('category', value);
        if (window.location.href.indexOf('/app/map/') > -1) {
          window.location.reload();
        } else {
          navigate('/app/map/');
        }
      }
    }
  };

  return (
    <>
      {appValue === 'seelsorge' && (
        <ul {...props}>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categoriesSeelsorge.seelsorge.value);
              }}
            >
              <img
                css={css`
                  width: 40px;
                `}
                alt="Seelsorge Logo"
                src="/herz.png"
              />
            </ExternalLink>
          </li>
        </ul>
      )}
      {appValue === 'work' && (
        <ul {...props}>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categoriesWork.film.value);
              }}
            >
              <img
                css={css`
                  width: 40px;
                `}
                alt="Film Logo"
                src="/film.png"
              />
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categoriesWork.computer.value);
              }}
            >
              <img
                css={css`
                  width: 40px;
                `}
                alt="Computer Logo"
                src="/computer.png"
              />
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categoriesWork.schreiben.value);
              }}
            >
              <img
                css={css`
                  width: 40px;
                `}
                alt="Schreiben Logo"
                src="/schreiben.png"
              />
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categoriesWork.datum.value);
              }}
            >
              <img
                css={css`
                  width: 40px;
                `}
                alt="Datum Logo"
                src="/datum.png"
              />
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categoriesWork.gluehbirne.value);
              }}
            >
              <img
                css={css`
                  width: 40px;
                `}
                alt="Schreiben Logo"
                src="/gluehbirne.png"
              />
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categoriesWork.agriculture.value);
              }}
            >
              <img
                css={css`
                  width: 50px;
                `}
                alt="Erntehelfer"
                src="/traktor.png"
              />
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categoriesWork.network.value);
              }}
            >
              <img
                css={css`
                  width: 50px;
                `}
                alt="Network"
                src="/haende.png"
              />
            </ExternalLink>
          </li>
        </ul>
      )}
      {appValue === 'nachbarschaft' && (
        <ul {...props}>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categories.shopping.value);
              }}
            >
              <svg
                id="Ebene_1"
                data-name="Ebene 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 406.36 406.38"
                css={css`
                  -webkit-flex: 0 0 auto;
                  -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
                  min-width: 40px;
                  min-height: 20px;
                  @media ${media.small} {
                    min-width: 50px;
                    min-height: 50px;
                  }
                `}
              >
                <title>TOGETHERE</title>
                <path
                  d="M222.35,351.21C212.15,348.47,204,343,202,332.12c-1.09-6.09.27-12.61.54-19.3-2.35-1.12-6.22-2.37-9.44-4.59-7.93-5.46-11-13.45-11-23,.06-43.2,0-86.41.14-129.61,0-4.29-1-6.53-5.22-8.06-8-2.88-15.76-6.44-23.59-9.79-4.77-2-6.48-5.27-4.86-8.84s4.91-4.57,9.79-2.55c10.34,4.28,20.61,8.72,31,12.94,3.79,1.54,5.36,4,5.26,8.1-.17,6.67-.05,13.34-.05,20.45,12.9,1.82,25.42,3.61,38,5.34q46,6.35,91.93,12.64c8.44,1.16,16.88,2.39,25.34,3.46,6.51.83,8.22,2.53,8.23,8.88,0,16.41.06,32.83,0,49.24-.06,15.23-11.14,26.38-26.25,26.4-41,0-82,.08-123.08-.09-4.53,0-9.06-1.42-13.8-2.22,0,5.81-.54,12,.14,18,.82,7.15,6.44,11.12,14.38,11.12q51.75,0,103.49,0c4.36,0,8.71-.05,13.07,0,12.94.17,23.38,8.86,25.11,20.82,2,13.63-5.24,24.79-18.51,28.74a9.43,9.43,0,0,0-1.68.9h-9c-1.38-.53-2.74-1.08-4.12-1.57-10.21-3.69-17.23-13.74-16.55-24.42.26-4,1.52-8,2.33-12H249.67c.5,5.65,2,11.32,1.27,16.7-1.55,11.78-9.68,18.06-20.55,21.3ZM195,180.47a11.8,11.8,0,0,0-.45,2c0,21.76-.15,43.51,0,65.27.07,8.75,5.83,13.83,15,13.84q60.26,0,120.5,0c10.22,0,15.49-5.26,15.54-15.43.06-11,0-22.09,0-33.14,0-12.22,0-11.93-12.32-13.54-28-3.67-55.95-7.66-83.93-11.51C231.43,185.47,213.4,183,195,180.47ZM213.4,326a13.15,13.15,0,0,0,12.87,12.77c6.84,0,12.89-6,12.91-12.77a12.89,12.89,0,1,0-25.78,0Zm100.26.15a12.7,12.7,0,1,0,25.39-.78,12.7,12.7,0,0,0-25.39.78Z"
                  css={css`
                    fill: ${appColor};
                  `}
                />
              </svg>
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categories.doc.value);
              }}
            >
              <svg
                id="Ebene_1"
                data-name="Ebene 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 406.36 406.38"
                css={css`
                  -webkit-flex: 0 0 auto;
                  -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
                  min-width: 40px;
                  min-height: 20px;
                  @media ${media.small} {
                    min-width: 50px;
                    min-height: 50px;
                  }
                `}
              >
                <title>TOGETHERE</title>
                <path
                  d="M301.7,367.65H270.93a20.75,20.75,0,0,1-20.72-20.72v-46h-46a20.75,20.75,0,0,1-20.73-20.73V249.42a20.75,20.75,0,0,1,20.73-20.72h46v-46A20.75,20.75,0,0,1,270.93,162H301.7a20.75,20.75,0,0,1,20.72,20.73v46h46a20.74,20.74,0,0,1,20.72,20.72v30.76a20.75,20.75,0,0,1-20.72,20.73h-46v46A20.75,20.75,0,0,1,301.7,367.65ZM204.19,241.11a8.32,8.32,0,0,0-8.32,8.31v30.76a8.33,8.33,0,0,0,8.32,8.32h58.43v58.43a8.33,8.33,0,0,0,8.31,8.32H301.7a8.33,8.33,0,0,0,8.31-8.32V288.5h58.43a8.33,8.33,0,0,0,8.32-8.32V249.42a8.32,8.32,0,0,0-8.32-8.31H310V182.68a8.32,8.32,0,0,0-8.31-8.32H270.93a8.32,8.32,0,0,0-8.31,8.32v58.43Z"
                  css={css`
                    fill: ${appColor};
                  `}
                />
              </svg>
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categories.walkthedog.value);
              }}
            >
              <svg
                id="Ebene_1"
                data-name="Ebene 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 406.36 406.38"
                css={css`
                  -webkit-flex: 0 0 auto;
                  -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
                  min-width: 40px;
                  min-height: 20px;
                  @media ${media.small} {
                    min-width: 50px;
                    min-height: 50px;
                  }
                `}
              >
                <title>TOGETHERE</title>
                <path
                  d="M176.51,382.81c-1,0-1.93,0-2.88-.06-6.1-.34-10.39-4.07-11.5-10s-2.19-11.86-3.28-17.8q-1.51-8.3-3-16.58A14,14,0,0,1,158.56,327c1.79-2.38,3.56-4.79,5.33-7.2,2.23-3,4.45-6.08,6.73-9.07A66.59,66.59,0,0,1,164,280.22a51.89,51.89,0,0,1,6.29-23.41c-1-.37-1.94-.75-2.9-1.15a70.22,70.22,0,0,1-34.57-31.37c-3.36-6-1.56-13,4.19-16.23,5.93-3.31,12.57-1.14,16.15,5.24a47.89,47.89,0,0,0,24.1,21.49c8,3.36,16.41,3.69,26.6,3.16q21.72-1.12,43.44-2.08l26.8-1.25c7.53-.37,15.07-.73,22.6-1l25.62-70.7c.39-1.12.6-1.7.84-2.28a11.56,11.56,0,0,1,21.88,1c.26.85.51,1.7.76,2.55a11.29,11.29,0,0,1,10.56-1.84c4.74,1.52,7.67,5.44,8.05,10.77.12,1.72.28,3.43.44,5.15s.29,3.16.41,4.74c6.62,2.91,11.3,8,13.95,15.26,6.13,2.6,12.31,5.08,18.51,7.5a15.24,15.24,0,0,1,8.7,7.51l.62,1.28v5.49l-.68,1.34c-9.74,19-24.94,28.57-45.18,28.57h-.43l-5.28,24.23c-2.06,9.45-4.12,18.89-6.24,28.32a27.33,27.33,0,0,1-7.12,13.7q-.06,20.78,0,41.45v11c0,3.37-.39,7.63-3.45,10.69s-7.28,3.45-10.65,3.45h-.73a22.86,22.86,0,0,1-3.42-.13c-5.72-.72-9.53-4.51-10.47-10.4q-4.11-25.94-8.15-51.86-33.59-5.7-66.92-11.45a65,65,0,0,1-10.52,11c-11.28,8.79-22.93,17.44-34.19,25.8l-5.37,4c.93,4.55,1.73,9.09,2.53,13.62l.85,4.79a11.72,11.72,0,0,1-11.88,14.6C178.61,382.79,177.54,382.81,176.51,382.81Zm2.94-11.69Zm-5.15-.8c1.89.12,3.42.07,5,.05h.14l-.86-4.82c-.87-4.92-1.73-9.83-2.76-14.71a9.5,9.5,0,0,1,4-10.25l6.42-4.78c11.21-8.32,22.8-16.93,34-25.63,3.17-2.46,5.91-5.8,8.91-9.58a10.11,10.11,0,0,1,10.3-4.06q34.2,5.94,68.4,11.71c6.57,1.12,8.61,3.18,9.61,9.6,2.74,17.59,5.48,35,8.25,52.46v0a9.31,9.31,0,0,0,1.47,0H328a5.73,5.73,0,0,1,1.65-.07,16.27,16.27,0,0,0,.07-1.66v-11q0-21,0-42.07c0-1.49.31-5.19,3-7.59,2.15-1.89,3.54-4.5,4.39-8.22q3.16-14.1,6.22-28.24L351,236.73l7.19.63c.81.09,1.58.18,2.35.19,15,.38,26.11-6.26,33.75-19.77a8.61,8.61,0,0,0-1-.45c-6.59-2.58-13.17-5.22-19.69-8a11,11,0,0,1-5.78-6.29c-1.57-4.63-4.22-7.5-8.34-9s-6.14-4.42-6.42-8.79c-.12-1.93-.3-3.87-.48-5.81-.12-1.35-.25-2.7-.36-4.06l-2.9,3.16-8.83,9.62-3.66-10.84c-.22-.63-.4-1.18-.56-1.72l-1.12-3.86c-.4-1.4-.8-2.8-1.21-4.19l-26,71.84c-1.53,4.27-4.3,6.41-8.28,6.55-8.28.3-16.55.7-24.83,1.1l-26.83,1.26c-14.46.66-28.91,1.32-43.36,2.08a105.1,105.1,0,0,1-16-.19l.59.22L185,256.89c-.53.86-.76,1.23-1,1.57a38.7,38.7,0,0,0-7.51,22.18,53.84,53.84,0,0,0,5.8,25.66A10.16,10.16,0,0,1,181,317.58c-2.41,3.16-4.77,6.38-7.12,9.59-1.8,2.45-3.59,4.89-5.41,7.32-.61.81-.59,1.13-.49,1.62q1.55,8.31,3.06,16.63Q172.67,361.53,174.3,370.32ZM379.49,199s0,0,0,0S379.5,199,379.49,199Zm-1.1-1.08h0Z"
                  css={css`
                    fill: ${appColor};
                  `}
                />
              </svg>
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categories.repairs.value);
              }}
            >
              <svg
                id="Ebene_1"
                data-name="Ebene 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 406.36 406.38"
                css={css`
                  -webkit-flex: 0 0 auto;
                  -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
                  min-width: 40px;
                  min-height: 20px;
                  @media ${media.small} {
                    min-width: 50px;
                    min-height: 50px;
                  }
                `}
              >
                <title>TOGETHERE</title>
                <path
                  d="M351.58,375.54h-8l-3.5-1.28a56.49,56.49,0,0,1-6.75-2.73,25.82,25.82,0,0,1-6.49-5Q297,336.8,267.23,307L242.4,282.19q-11.86-11.85-23.7-23.73a51.67,51.67,0,0,1-20.34,1.1,53.21,53.21,0,0,1-34.06-18.9c-14-11.17-12.67-41.39-11.27-47.15,1.1-4.58,4-5.69,5.69-5.95,4.17-.67,5.9.78,22.95,19,2.55,2.74,4.94,5.3,6.8,7.23,3.4-.93,6.81-1.83,10.22-2.74,3.12-.82,6.24-1.64,9.35-2.49q2.66-9.73,5.18-19.5-9.06-9.19-18.26-18.34a20,20,0,0,0-2.11-1.64c-2.74-2-5.34-3.9-5.8-7.26l-.36-2.61,1.72-2.43c4.1-5.25,27.32-3.35,27.71-3.29h0A53.62,53.62,0,0,1,258.29,217q14.9,14.81,29.71,29.68l79.58,79.56a28.58,28.58,0,0,1,8.34,16.24l.16.46.23,1.65-.21,6.7-.32,1.18c-1.95,8.65-6.56,15-13.72,19a39.31,39.31,0,0,1-6.92,2.81c-.84.28-1.68.56-2.51.87Zm-5.77-12.41h3.56l1.86-.63a30.63,30.63,0,0,0,4.83-1.89c4-2.2,6.46-5.74,7.61-10.84q.1-.47.24-.93v-3.18a6.16,6.16,0,0,1-.21-1,16.27,16.27,0,0,0-4.89-9.63l-79.59-79.57q-15.35-15.36-30.72-30.68a9.19,9.19,0,0,1-2.59-9.28,39.48,39.48,0,0,0,.24-17.6A40.62,40.62,0,0,0,214,165.75c-1-.09-3.56-.09-6.48-.05q8.13,8.15,16.21,16.34a8.64,8.64,0,0,1,2.13,7.93q-3.1,12.1-6.41,24.15a8.58,8.58,0,0,1-5.8,5.83c-3.91,1.07-7.82,2.1-11.74,3.14s-8.09,2.14-12.13,3.25A8.52,8.52,0,0,1,181,224c-2-2-5.09-5.31-8.42-8.89-2.3-2.46-5.29-5.67-8.07-8.57.35,9,2.39,20.76,7.74,24.63l1.16,1.1a40.68,40.68,0,0,0,26.72,15.06A40.24,40.24,0,0,0,217.27,246a8.19,8.19,0,0,1,8.58,2.06q12.63,12.69,25.32,25.35L276,298.23q29.78,29.77,59.58,59.54a15.22,15.22,0,0,0,3.28,2.67,46.19,46.19,0,0,0,5.33,2.12Z"
                  css={css`
                    fill: ${appColor};
                  `}
                />
                <circle
                  cx="340.99"
                  cy="338.33"
                  r="6.99"
                  css={css`
                    fill: ${appColor};
                  `}
                />
              </svg>
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categories.education.value);
              }}
            >
              <svg
                id="Ebene_1"
                data-name="Ebene 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 406.36 406.38"
                css={css`
                  -webkit-flex: 0 0 auto;
                  -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
                  min-width: 40px;
                  min-height: 20px;
                  @media ${media.small} {
                    min-width: 50px;
                    min-height: 50px;
                  }
                `}
              >
                <title>TOGETHERE</title>
                <path
                  d="M279.3,348.41c-35.54,0-73.31-11.56-73.31-33V251.94H218.4v63.48c0,8.39,23.72,20.58,60.9,20.58s60.91-12.19,60.91-20.58V251.13h12.41v64.29C352.62,336.85,314.85,348.41,279.3,348.41Z"
                  css={css`
                    fill: ${appColor};
                  `}
                />
                <path
                  d="M279.69,286.19a12.61,12.61,0,0,1-4.91-1L157,235.69a14.93,14.93,0,0,1,.57-27.25L275.37,165.5a12.57,12.57,0,0,1,8.84.08l112.07,42.93a14.94,14.94,0,0,1,.59,27.09L284.8,285.1A12.59,12.59,0,0,1,279.69,286.19Zm.08-109-118,42.94c-.73.27-1,1.38-1,2s.17,1.82.95,2.15L279.6,273.76a.19.19,0,0,0,.18,0l112.08-49.51c.78-.33,1-1.51.94-2.15s-.23-1.72-1-2Z"
                  css={css`
                    fill: ${appColor};
                  `}
                />
                <rect
                  x="375.47"
                  y="235.53"
                  width="12.41"
                  height="58.55"
                  css={css`
                    fill: ${appColor};
                  `}
                />
                <ellipse
                  cx="381.83"
                  cy="298.31"
                  rx="8.55"
                  ry="9.79"
                  css={css`
                    fill: ${appColor};
                  `}
                />
              </svg>
            </ExternalLink>
          </li>
          <li>
            <ExternalLink
              onClick={() => {
                onClickIcon(categories.gardening.value);
              }}
            >
              <svg
                id="Ebene_1"
                data-name="Ebene 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 406.36 406.38"
                css={css`
                  -webkit-flex: 0 0 auto;
                  -ms-flex: 0 0 auto;
                  flex: 0 0 auto;
                  min-width: 40px;
                  min-height: 20px;
                  @media ${media.small} {
                    min-width: 50px;
                    min-height: 50px;
                  }
                `}
              >
                <title>TOGETHERE</title>
                <path
                  d="M267.58,353.67l-2.53-1.13c-4.41-2-43-20-43-45V250.58h91.14v56.93c0,25-38.63,43.05-43,45ZM234.42,263v44.52c0,13.26,22.36,27.12,33.16,32.49,10.8-5.37,33.16-19.23,33.16-32.49V263Z"
                  css={css`
                    fill: ${appColor};
                  `}
                />
                <rect
                  x="261.38"
                  y="182.16"
                  width="12.41"
                  height="73.78"
                  css={css`
                    fill: ${appColor};
                  `}
                />
                <rect
                  x="261.38"
                  y="257.29"
                  width="12.41"
                  height="42.45"
                  css={css`
                    fill: ${appColor};
                  `}
                />
                <path
                  d="M267.58,191a8.87,8.87,0,0,1-6.86-3.24l-16.52-20a8.9,8.9,0,0,1,6.87-14.56h33A8.9,8.9,0,0,1,291,167.8l-16.51,20A8.87,8.87,0,0,1,267.58,191Zm-9.07-25.39,9.07,11,9.07-11Zm22.88-5.75h0Z"
                  css={css`
                    fill: ${appColor};
                  `}
                />
              </svg>
            </ExternalLink>
          </li>
        </ul>
      )}
    </>
  );
};

export default IconMenu;
